export const generateLoginUrl = (organization, redirect) => {
  const encodedRedirect = encodeURIComponent(redirect || `/${organization}`);
  return `/${organization}/login?returnUri=${encodedRedirect}`;
};
